export default "__VITE_ASSET__WDRu9ZP1__"